import {
  Coffee,
  Cookie,
  Cup,
  Grill,
  Meat,
  Pizza,
  Soup,
  Store,
} from "@pillar-ui/icons";
import { RESTAURANT_TYPE } from "./constants";
import LunarJS from "lunar-javascript";

export const getRestaurantTypeIcon = (type) => {
  switch (type) {
    case RESTAURANT_TYPE.CAFE:
      return Coffee;
    case RESTAURANT_TYPE.FASTFOOD:
      return Pizza;
    case RESTAURANT_TYPE.GRILL:
    case RESTAURANT_TYPE.HOT_POT:
      return Grill;
    case RESTAURANT_TYPE.MILK_TEA:
      return Cup;
    case RESTAURANT_TYPE.OTHERS:
      return Meat;
    case RESTAURANT_TYPE.RICE:
      return Cookie;
    case RESTAURANT_TYPE.BUFFET:
      return Store;
    default:
      return Soup;
  }
};

export const randomHexColor = () => {
  // Generate a random number from 0 → 16777215 (0xFFFFFF)
  const randomInt = Math.floor(Math.random() * 0xffffff);

  // Convert to hex and pad with leading zeros if necessary
  const hex = randomInt.toString(16).padStart(6, "0");

  return `#${hex}`;
};

/**
 * Get Lunar New Year date for a given Gregorian year
 * @param {number} year - Gregorian year (e.g., 2026)
 * @returns {string} - Lunar New Year date in YYYY-MM-DD format
 */
export const getLunarNewYear = (year) => {
  if (!Number.isInteger(year) || year < 1900 || year > 2100) {
    throw new Error("Year must be an integer between 1900 and 2100.");
  }

  // Direct approach: create Lunar date for 1st month, 1st day
  const lunar = LunarJS.Lunar.fromYmd(year, 1, 1);
  const solar = lunar.getSolar();

  return {
    day: solar.getDay(),
    month: solar.getMonth(),
    year: solar.getYear(),
  };
};

export const checkHoliday = () => {
  const currentDate = new Date();
  const day = currentDate.getDate();
  const month = currentDate.getMonth() + 1;

  // Check Independence Day
  if (month === 8 && day <= 10) {
    return "independence";
  }

  // Check Halloween
  if ((month === 9 || month === 10) && (day > 21 || day < 10)) {
    return "halloween";
  }

  // Check Lunar New Year
  const lunarDate = getLunarNewYear(currentDate.getFullYear());
  if (lunarDate.day - 10 < 0) {
    if (
      (day <= lunarDate.day + 10 || day >= 31 - (10 - lunarDate.day)) &&
      (month === lunarDate.month - 1 || month === lunarDate.month)
    ) {
      return "lunar";
    }
  }
  if (
    month === lunarDate.month &&
    day >= lunarDate.day - 10 &&
    day <= lunarDate.day + 10
  ) {
    return "lunar";
  }

  // Hardcode
  return "lunar";
};
